export default __webpack_public_path__ + "static/media/contacts-color.4ca9b137.svg";